// extracted by mini-css-extract-plugin
export default {"wrapper":"Hz-z","viewport":"Iz-z","container":"Jz-z","slide":"Kz-z"};